var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { staticClass: "burger", on: { click: _vm.handleClick } },
    [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }